import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { M4PassKey } from 'src/app/model/M4PassKey';
import {Clipboard} from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';

@Component({
  selector: 'ms-passkeyotp-view',
  templateUrl: './passkeyotp-view.component.html',
  styleUrls: ['./passkeyotp-view.component.scss']
})
export class PasskeyotpViewComponent {
  public cmsObj: CmsObject[];
  public passKeyOkIntroduction: string;
  public passKeyOkDetails: string;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: M4PassKey,
    private clipboard: Clipboard,
    private _snackBar: MatSnackBar,
    public cmsService: CmsService,
    public workFlow: WorkFlowService,
  ) {}
  async  ngOnInit(){
    await this.getCmsObj();
  }
  copyOtp(){
    this.clipboard.copy(this.data.OTPToken);
    this._snackBar.open("OTP copied to clipboard!", "", { duration: 3000 });
  }
  async getCmsObj() {
    //recupero le stringhe della pagina
    this.cmsObj = await this.cmsService.getCmsObj(this.workFlow.getLanguageForCms(), 'passKeyOk');
    this.passKeyOkIntroduction = this.cmsObj.find((x) => x.ContentName == 'passKeyOk.introduction').ContentTranslation;
    this.passKeyOkDetails = this.cmsObj.find((x) => x.ContentName == 'passKeyOk.detailsOTP').ContentTranslation;
  }
}
